import type { ConversationStatus } from 'lib-shared-types-api';

import { conversationStatusAttributes } from 'utils/conversation/conversationAttributes';

import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
import { ConversationsStaticFilterConfig } from '../static/conversationsStaticFilter.types';

/** The list of statuses conversations can be filtered by. */
const statuses: readonly ConversationsStaticFilterConfig['status'][] = (
  Object.keys(conversationStatusAttributes) as readonly ConversationStatus[]
)
  // Exclude `awaitingpending` as it is covered by the `open` status.
  .filter((status) => status !== 'awaitingpending')
  .map((status) => ({
    id: status,
    name: conversationStatusAttributes[status].label,
  }));

/** Represents the component for filtering the conversations by status. */
export const ConversationsStatusFilter = (): JSX.Element => (
  <ConversationsStaticFilter type="status" items={statuses} />
);
